import { put, call, take } from "redux-saga/effects";
import { Action } from "./reducer";
import { createSsoLoginUrl } from "./actions";
import { createSsoLoginRequest } from "./api";

export function* createSsoLoginUrlSaga(payload: any): Generator {
  try {
    const response: any = yield call(createSsoLoginRequest, payload);
    yield put(createSsoLoginUrl.success(response));
  } catch (err) {
    yield put(createSsoLoginUrl.failure(err));
  }
}

export function* ssoLoginFlow() {
  while (true) {
    const action: Action = yield take(createSsoLoginUrl.request);
    if (!action) {
      continue;
    }
    yield call(createSsoLoginUrlSaga, action.payload);
    break;
  }
}

export default [ssoLoginFlow()];
